import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { resolve } from 'url';
const moment = extendMoment(Moment);

@Injectable({
  providedIn: 'root'
})
export class TimeSheetService {
  constructor(private http: HttpClient) { }
  private systemDate = new Subject<any>();
  //   public static systemDate
  addTime(data: any): Observable<any> {
    console.log("Adding Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "time-log", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log("response from service", res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED response is")
          observer.complete();
        })

    });
  }

  editTime(data: any): Observable<any> {
    console.log("Editing Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "time-log", data).subscribe((res: any) => {
        observer.next(res.data);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  deleteTime(data: any): Observable<any> {
    console.log("Deleting Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.delete(config.baseApiUrl + "time-log", data).subscribe((res: any) => {
        observer.next(res.data.timeLog);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getInstructorTimeLog(data): Observable<any> {
    // console.log("get time log", id);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "time-log/instructor?_id=" + data).subscribe((res: any) => {
        observer.next(res.result);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  getTimeLogUsingDates(data: any): Observable<any> {
    // const obj = { date: data }
    console.log("get time log", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "time-log/ins", data).subscribe((res: any) => {

        console.log("response from service========>>>>>>>>", res);

        observer.next(res.response);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }
  getWeeklyStatus(data: any): Observable<any> {
    // const obj = { date: data }
    // console.log("get time log", obj);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "time-log/instructor/week", data).subscribe((res: any) => {
        observer.next(res);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }
  getMultipleInstructorTime(data): Observable<any> {
    // const obj = { date: data }
    // console.log("get time log", obj);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "time-log/ins-time", data).subscribe((res: any) => {
        observer.next(res);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }
  getSecondReportDetails(data): Observable<any> {
    // const obj = { date: data }
    // console.log("get time log", obj);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "time-log/secondReport", data).subscribe((res: any) => {
        observer.next(res);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  generatePdf(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.post(config.baseApiUrl + "time-log/pdf", data).subscribe((res: any) => {
        observer.next(res.data);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  generatePdfReportA(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.post(config.baseApiUrl + "time-log/firstreport/pdf", data).subscribe((res: any) => {
        observer.next(res.data);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  generatePdfReportB(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.post(config.baseApiUrl + "time-log/secondreport/pdf", data).subscribe((res: any) => {
        observer.next(res.data);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  generateWeekReport(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.post(config.baseApiUrl + "time-log/weekreport/pdf", data).subscribe((res: any) => {
        observer.next(res.data);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  newDateObservable(): Observable<any> {
    return this.systemDate.asObservable();
  }

  getSystemDate(): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "time-log/systemDate").subscribe((res: any) => {
        this.systemDate.next({ date: res.data.systemDate })
        observer.next(res.data);
        console.log("response from service", res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  generateMonthWeeks(selectedMonths, currentYear?) {
    console.log("What is in the selected months", selectedMonths, currentYear);

    return new Promise((resolve, reject) => {
      let selectedWeeks = []
      let allWeeks = [];
      // this.monthChanged = true
      if (selectedMonths) {
        console.log(selectedMonths.id)
        let month = selectedMonths.id
        return new Promise((resolve, reject) => {

          let year = moment().year()
          let startDate = moment.utc([year, month])
          console.log("THIS IS THE START DATE DEFAULT", startDate)
          let monthStart = moment(startDate).startOf('month')
          let monthEnd = moment(startDate).endOf('month')
          let totalWeeks = moment(year).weeksInYear()
          let monthStartWeekNumber = moment(monthStart).isoWeek()
          let monthEndWeekNumber = moment(monthEnd).isoWeek()
          console.log("monthStartWeekNumber", monthStartWeekNumber, "monthEndWeekNumber", monthEndWeekNumber);
          if (monthEndWeekNumber == 1) monthEndWeekNumber = 52
          if (monthStartWeekNumber == totalWeeks) monthStartWeekNumber = 0
          for (let i = monthStartWeekNumber; i <= monthEndWeekNumber; i++) {
            console.log("in loop", i);
            let weekStartDate = moment().startOf('isoWeek').isoWeek(i);
            if (i == 1 && weekStartDate < moment().startOf('year')) weekStartDate = moment().startOf('year');
            // let weekEndDate = moment('2020').startOf('week').day('Saturday').week(i);
            let weekEndDate = moment().endOf('isoWeek').isoWeek(i);
            // console.log("weekEndDate", weekEndDate.date(), weekEndDate.month());
            if (weekEndDate > moment().endOf('year')) {
              // console.log("weekEndDate > moment().endOf('year')", weekEndDate, moment().endOf('year'));
              weekEndDate = moment().endOf('year')
            }
            let tempStartDate = weekStartDate
            let tempEndDate = weekEndDate
            allWeeks.push({
              weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate,
              from: tempStartDate.format('MM/DD/YYYY'),
              to: tempEndDate.format('MM/DD/YYYY'),
              bothDates: "From: " + tempStartDate.format('MM/DD/YYYY') + " - " + "To: " + tempEndDate.format('MM/DD/YYYY')
            })
            console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
          }
          // this.show = true;
          console.log("$$allWeeks", allWeeks);
          resolve(allWeeks)
        }).then((resolvedAllWeeks) => {
          console.log("---resolvedAllWeeks-- in AFTER FOR LOOP", resolvedAllWeeks);
          resolve({ allWeeks: allWeeks, datesRange: resolvedAllWeeks })
          // this.datesRange = resolvedAllWeeks
        })
      }

    })
  }


  calculateMonthWeeks(monthName, year) {
    return new Promise((resolve, reject) => {
      let allWeeks = [];
      if (monthName) {
        return new Promise((resolve, reject) => {
          let month = monthName.id
          let currentYear = year
          // console.log("THIS IS THE MONTH SELECTED", month)
          // console.log("THIS IS THE CURRENT YEAR", currentYear)
          let startDate = moment.utc([currentYear, month])
          console.log("THIS IS THE START DATE USING MONTH", startDate)
          let monthStart = moment(startDate).startOf('month')
          let monthEnd = moment(startDate).endOf('month')
          let totalWeeks = moment(currentYear).weeksInYear()
          let monthStartWeekNumber = moment(monthStart).isoWeek()
          let monthEndWeekNumber = moment(monthEnd).isoWeek()
          if (monthEndWeekNumber == 1) monthEndWeekNumber = 52
          if (monthStartWeekNumber == totalWeeks) monthStartWeekNumber = 0
          for (let i = monthStartWeekNumber; i <= monthEndWeekNumber; i++) {
            console.log("in loop", i);
            let weekStartDate = moment().year(currentYear).startOf('isoWeek').isoWeek(i);
            if (i == 1 && weekStartDate < moment().year(currentYear).startOf('year')) weekStartDate = moment().year(currentYear).startOf('year');
            // let weekEndDate = moment('2020').startOf('week').day('Saturday').week(i);
            let weekEndDate = moment().year(currentYear).endOf('isoWeek').isoWeek(i);
            // console.log("weekEndDate", weekEndDate.date(), weekEndDate.month());
            if (weekEndDate > moment().year(currentYear).endOf('year')) {
              // console.log("weekEndDate > moment().year(currentYear).endOf('year')", weekEndDate, moment().year(currentYear).endOf('year'));
              weekEndDate = moment().year(currentYear).endOf('year')
            }
            let tempStartDate = weekStartDate
            let tempEndDate = weekEndDate
            allWeeks.push({
              weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate,
              from: tempStartDate.format('MM/DD/YYYY'),
              to: tempEndDate.format('MM/DD/YYYY'),
              bothDates: "From: " + tempStartDate.format('MM/DD/YYYY') + " - " + "To: " + tempEndDate.format('MM/DD/YYYY')
            })
            console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
          }
          resolve(allWeeks)
        }).then((resolvedAllWeeks) => {
          console.log("THIS IS THE FINAL OUTPUT TO BE SEND", allWeeks)
          resolve({ allWeeks: allWeeks, datesRange: resolvedAllWeeks })
        })
      }
    })
  }

  getCurrentWeekDates(today) {
    console.log("What is the today date", today);
    return new Promise((resolve, reject) => {
      let curr = today
      let week = []
      for (let i = 1; i <= 7; i++) {
        let first = curr.getDate() - curr.getDay() + i
        let day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
        week.push(moment(day).format("MM/DD/YYYY"))
      }
      console.log("This is the week", week);
      resolve({ weekDates: week })
    })
  }

  generateWeekDates(selectedWeeks) {
    let dates = []
    return new Promise((resolve, reject) => {
      if (selectedWeeks && selectedWeeks.from) {
        let week = selectedWeeks
        console.log("-----getWeekDates-----", week);
        let temp = week.from.split(" ")
        // let weekStartDate = moment(temp[1])
        let weekStartDate = moment(week.from)
        // let weekEndDate = moment(temp[4])
        let weekEndDate = moment(week.to)
        console.log("**temp", temp);
        console.log("**weekStartDate", weekStartDate, "**weekEndDate", weekEndDate);


        // return new Promise((resolve,reject)=>{
        dates.push(week.from)
        return new Promise((resolve, reject) => {
          while (weekStartDate.add(1, 'days').diff(weekEndDate) < 0) {
            console.log("In while loop");
            // console.log(weekStartDate.toDate());
            dates.push(weekStartDate.clone().format('MM/DD/YYYY'));
          }
          dates.push(week.to)
          resolve(dates)
        }).then(resolvedDates => {
          console.log("this.generatedDates are", resolvedDates);
          // this.doCalWeekDates = false
          resolve({ dates: dates, weekDates: resolvedDates })
          // this.weekDates = resolvedDates
        })
      }
    })
  }


  filterDates(startDate, endDate, currentDate) {
    console.log("What is the start date and end date of page", startDate, endDate);

    return new Promise((resolve, reject) => {
      let selectedWeeks = []
      let allWeeks = [];
      let startDateYear = moment(startDate).year();
      let endDateYear = moment(endDate).year();
      let currentDateYear = moment(currentDate).year()
      console.log("Check the years date wise", startDateYear, endDateYear, currentDateYear);

      // this.monthChanged = true

      return new Promise(async (resolve, reject) => {
        let monthStart = moment(startDate).startOf('month')
        let monthEnd = moment(endDate).endOf('month')

        let monthStartWeekNumber = moment(monthStart).isoWeek()
        let monthEndWeekNumber = moment(monthEnd).isoWeek()
        console.log("monthStartWeekNumber", monthStartWeekNumber, "monthEndWeekNumber", monthEndWeekNumber);

        if (monthEndWeekNumber == 1) monthEndWeekNumber = 52
        if (monthStartWeekNumber == 53 || monthStartWeekNumber == 52) monthStartWeekNumber = 1
        // if (monthStartWeekNumber > monthEndWeekNumber) monthEndWeekNumber = monthEndWeekNumber + 52
        if (monthStartWeekNumber < monthEndWeekNumber) {
          console.log("After assign new value of month number", monthStartWeekNumber, monthEndWeekNumber);
          for (let i = monthStartWeekNumber; i <= monthEndWeekNumber; i++) {
            console.log("in loop", i);
            let weekStartDate
            let weekEndDate
            if (startDateYear === currentDateYear && endDateYear === currentDateYear) {
              weekStartDate = moment().startOf('isoWeek').isoWeek(i);
              if (i == 1 && weekStartDate < moment().startOf('year')) weekStartDate = moment().startOf('year');
              weekEndDate = moment().endOf('isoWeek').isoWeek(i);
              if (weekEndDate > moment().endOf('year')) weekEndDate = moment().endOf('year')
            } else if (startDateYear === endDateYear && (startDateYear < currentDateYear && endDateYear < currentDateYear)) {
              console.log("Call this for diff year");
              weekStartDate = moment(startDate).startOf('isoWeek').isoWeek(i);
              if (i == 1 && weekStartDate < moment(startDate).startOf('year')) weekStartDate = moment(startDate).startOf('year');
              weekEndDate = moment(endDate).endOf('isoWeek').isoWeek(i);
              if (weekEndDate > moment().endOf('year')) weekEndDate = moment(endDate).endOf('year')
            }

            console.log("What is the week start and end date", weekStartDate, weekEndDate);


            let tempStartDate = weekStartDate
            let tempEndDate = weekEndDate

            let checked = this.dateCheck(startDate, endDate, tempStartDate)
            console.log("this is the date checked push", checked);
            if (checked) {
              allWeeks.push({
                weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate,
                from: tempStartDate.format('MM/DD/YYYY'),
                to: tempEndDate.format('MM/DD/YYYY')
              })
            }
            console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
          }
        } else {
          console.log("Here it is call when week start number is more then end number", monthStartWeekNumber, monthEndWeekNumber);

          let oldYearArray = await this.createOnlyPreviousYearDates(monthStartWeekNumber, startDate, endDate)
          let newYearArray = await this.createOnlyCurrentYearDates(monthEndWeekNumber, startDate, endDate)
          console.log("THis is the after await", oldYearArray);
          allWeeks = oldYearArray.concat(newYearArray)
        }
        // this.show = true;
        console.log("$$allWeeks", allWeeks);
        resolve(allWeeks)
      }).then((resolvedAllWeeks) => {
        console.log("---resolvedAllWeeks-- in AFTER FOR LOOP", resolvedAllWeeks);
        resolve({ allWeeks: allWeeks, datesRange: resolvedAllWeeks })
        // this.datesRange = resolvedAllWeeks
      })


    })
  }



  createOnlyPreviousYearDates(monthStartWeekNumber, startDate, endDate) {
    let weekArray = []
    console.log("This is the month start week number", monthStartWeekNumber);

    for (let i = monthStartWeekNumber; i <= 52; i++) {
      console.log("in loop", i);
      let weekStartDate = moment(startDate).startOf('isoWeek').isoWeek(i);
      console.log("What is the week start date", weekStartDate);

      if (i == 1 && weekStartDate < moment().startOf('year')) weekStartDate = moment().startOf('year');
      // let weekEndDate = moment('2020').startOf('week').day('Saturday').week(i);
      let weekEndDate = moment(startDate).endOf('isoWeek').isoWeek(i);
      // console.log("weekEndDate", weekEndDate.date(), weekEndDate.month());
      if (weekEndDate > moment(startDate).endOf('year')) {
        // console.log("weekEndDate > moment().endOf('year')", weekEndDate, moment().endOf('year'));
        weekEndDate = moment(startDate).endOf('year')
      }
      let tempStartDate = weekStartDate
      let tempEndDate = weekEndDate

      let checked = this.dateCheck(startDate, endDate, tempStartDate)
      console.log("this is the date checked push", checked);
      if (checked) {
        weekArray.push({
          weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate,
          from: tempStartDate.format('MM/DD/YYYY'),
          to: tempEndDate.format('MM/DD/YYYY')
        })
      }
      console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
    }
    console.log("This is the final out put for week number for onlt 52", weekArray);
    return weekArray
  }


  createOnlyCurrentYearDates(monthEndWeekNumber, startDate, endDate) {

    let weekArray = []
    console.log("This is the month start week number", endDate);

    for (let i = 1; i <= monthEndWeekNumber; i++) {
      console.log("in loop", i);
      let weekStartDate = moment(endDate).startOf('isoWeek').isoWeek(i);
      console.log("What is the week start date", weekStartDate);

      if (i == 1 && weekStartDate < moment().startOf('year')) weekStartDate = moment().startOf('year');
      // let weekEndDate = moment('2020').startOf('week').day('Saturday').week(i);
      let weekEndDate = moment().endOf('isoWeek').isoWeek(i);
      // console.log("weekEndDate", weekEndDate.date(), weekEndDate.month());
      if (weekEndDate > moment().endOf('year')) {
        // console.log("weekEndDate > moment().endOf('year')", weekEndDate, moment().endOf('year'));
        weekEndDate = moment().endOf('year')
      }
      let tempStartDate = weekStartDate
      let tempEndDate = weekEndDate

      let checked = this.dateCheck(startDate, endDate, tempStartDate)
      console.log("this is the date checked push", checked);
      if (checked) {
        weekArray.push({
          weekNumber: i, weekStartDate: weekStartDate, weekEndDate: weekEndDate,
          from: tempStartDate.format('MM/DD/YYYY'),
          to: tempEndDate.format('MM/DD/YYYY')
        })
      }
      console.log("weekNumber: i", i, "weekStartDate", weekStartDate, "weekEndDate", weekEndDate);
    }
    console.log("This is the final out put for week number for after 52", weekArray);
    return weekArray


  }


  dateCheck(from, to, check) {
    var fDate, lDate, cDate;
    fDate = Date.parse(from);
    lDate = Date.parse(to);
    cDate = Date.parse(check);

    if ((cDate <= lDate && cDate >= fDate)) {
      return true;
    }
    return false;
  }


  getYearList() {
    return new Promise(async (resolve, reject) => {
      await this.getSystemDate().subscribe((date) => {
        const currentYear = moment(date.systemDate).year()
        let yearList = []
        yearList = yearList.concat(this.calculateYears(currentYear, 5, '-'))
        yearList = yearList.concat(this.calculateYears(currentYear, 5, '+'))
        console.log("CURRENT DATE IN SERVICE", date, currentYear, yearList)
        resolve({ currentYear: currentYear, yearList: yearList, systemDate: date.systemDate })
      })
    })
  }


  calculateYears(year, count, sign) {
    let list = []
    for (let i = sign == '+' ? 1 : 0; i < count; i++) {
      let tempYear = year
      if (sign === '+') tempYear = Number(tempYear) + i
      else tempYear = Number(tempYear) - i
      list.push(tempYear)
    }
    if (sign === '+') return list
    else return list.reverse()
  }

  getRailWeekDates(query): Observable<any> {
    return new Observable<any>((observer) => {
      this.http
        .get(config.baseApiUrl + "user-timelog/weekdates?_query=" + JSON.stringify(query))
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (error) => {
            observer.error(error);
          },
          () => {
            observer.complete();
          }
        );
    });
  }
}

